import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { MutationBitbucketCloudIntegrationUpdateV2Args } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { UPDATE_BITBUCKET_CLOUD_INTEGRATION_V2 } from "./gql";

const useUpdateBitbucketCloudIntegrationV2 = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [bitbucketCloudIntegrationUpdate, { loading }] = useMutation(
    UPDATE_BITBUCKET_CLOUD_INTEGRATION_V2,
    {
      refetchQueries: ["SearchVCSIntegrations"],
    }
  );

  const updateBitbucketCloudIntegration = useCallback(
    (input: MutationBitbucketCloudIntegrationUpdateV2Args, successCallback?: () => void) => {
      bitbucketCloudIntegrationUpdate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.bitbucketCloudIntegrationUpdateV2) {
            reportSuccess({
              message: `Integration ${data.bitbucketCloudIntegrationUpdateV2.name} was successfully updated`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Integration Edit - Finish", {
              integration: "Bitbucket Cloud",
            });
          }
        })
        .catch(onError);
    },
    [bitbucketCloudIntegrationUpdate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    updateBitbucketCloudIntegration,
    loading,
  };
};

export default useUpdateBitbucketCloudIntegrationV2;
